var map = {
	"./320px-IBM_logo.svg.png": 5892,
	"./3DSlicerLogo.png": 4494,
	"./4Square.png": 213,
	"./Amazon_icon.svg.png": 1380,
	"./GUI.png": 645,
	"./IBM_logo_square.svg.png": 2198,
	"./MichiganLogo.jpg": 9441,
	"./Stanford_Coursera_Logo.jpg": 6190,
	"./calculator.jpg": 2306,
	"./colon.png": 4077,
	"./encryptedeye.png": 2677,
	"./folder.jpg": 7270,
	"./hc-logo.png": 4901,
	"./house-graph.jpg": 1715,
	"./k-logo.jpg": 2375,
	"./kinaxis-logo.svg.png": 7641,
	"./perk-icon.png": 4570,
	"./pokeball.jfif": 4929,
	"./profilePic.jpg": 6987,
	"./qbitLogo.jpg": 8309,
	"./qmind-icon.png": 2959,
	"./queens-logo.jpg": 7043,
	"./qweb-icon.png": 5685,
	"./shopify_glyph3.png": 242,
	"./tree.png": 5738,
	"./turtlebotPi.jpg": 5796,
	"./val-icon.png": 9743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 452;